import FieldMixins from './mixins/field_mixin.js';

import { VISIBILITIES } from './constants.js';

const CalculationField = Vue.extend({
  mixins: [FieldMixins],

  template: `
    <FieldView :editing='editing'
               :field='field'
               :visibilities='visibilities'
               :field_groups='field_groups'
               :layouts='availableLayouts'
               ref='fieldView'>
      <template slot='content'>
        <div :class="(editing ? 'edit' : 'display') + '-content'">
          <div class="input-container">
            <textarea
              placeholder='编辑计算公式'
              rows='5'
              :readonly='!editing'
              v-model.lazy='execedJS'></textarea>
          </div>
        </div>
      </template>
    </FieldView>
  `,

  computed: {
    visibilities: function() {
      return VISIBILITIES.slice(1);
    },

    execedJS: {
      get: function() {
        return this.field.data.execed_js;
      },
      set: function(val) {
        this.field.data.execed_js = val;
      }
    }
  }
});

export default CalculationField;
